import React from "react";
import classNames from "classnames";
import styles from "./styles/FloatingLabelSelect.module.css";

export default function InputLabel({ active, labelText, children, value }) {
  return (
    <div style={{ display: "flex", flexFlow: "column-reverse", height: "40px" }}>
      {children}
      <span
        className={classNames(styles.selectLabel, {
          [styles.floatingSelectLabel]: active || value,
        })}
      >
        <span className={classNames(styles.selectLabelText)}>{labelText}</span>
      </span>
    </div>
  );
}
